angular.module('converter.distance', [])
	.factory('DistanceConverterSvc', function () {
		var unitRatios = {
			// metric
			mm: 0.001,
			cm: 0.01,
			dm: 0.1,
			m: 1,
			km: 1000,
			// imperial
			mi: 1609.34,
			yd: 0.9144,
			in: 0.0254
		};

		var convertToMetres = function (input, inputUnits) {
			input = input || 0;
			inputUnits = inputUnits || 'm';
			return input * unitRatios[inputUnits];
		};

		var convertFromMetres = function (input, outputUnits) {
			input = input || 0;
			outputUnits = outputUnits || 'm';
			return input / unitRatios[outputUnits];
		};

		var convert = function (input, inputUnits, outputUnits) {
			return convertFromMetres(convertToMetres(input, inputUnits), outputUnits);
		};

		return {
			UNIT_RATIOS: angular.copy(unitRatios),
			convertToMetres: convertToMetres,
			convertFromMetres: convertFromMetres,
			convert: convert
		};
	})
	.filter('convertDistance', function (DistanceConverterSvc) {
		return function (input, inputUnits, outputUnits) {
			return DistanceConverterSvc.convert(input, inputUnits, outputUnits);
		};
	})
;
